"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Label =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Label, _Component);

  function Label(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Label);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Label).call(this, props));
    _this.handleHover = _this.handleHover.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    return _this;
  }

  (0, _createClass2.default)(Label, [{
    key: "handleHover",
    value: function handleHover(event) {
      var isHovered = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var _this$props = this.props,
          disabled = _this$props.disabled,
          handleHover = _this$props.handleHover,
          isMobile = _this$props.isMobile,
          labelHover = _this$props.labelHover;

      if (disabled) {
        return;
      }

      if (handleHover && labelHover && !isHovered) {
        handleHover(event, false);
      } else if (handleHover) {
        handleHover(event, isHovered);
      }

      if (isMobile) {
        event.stopPropagation();
      }
    }
  }, {
    key: "renderLabel",
    value: function renderLabel() {
      var _this$props2 = this.props,
          label = _this$props2.label,
          labelChildren = _this$props2.labelChildren,
          labelTag = _this$props2.labelTag,
          labelTagClassName = _this$props2.labelTagClassName;

      if (!_react.default.isValidElement(label)) {
        var Tag = labelTag;

        if (labelChildren) {
          return _react.default.createElement(Tag, {
            className: labelTagClassName
          }, labelChildren);
        }

        return (// eslint-disable-next-line react/no-danger
          _react.default.createElement(Tag, {
            className: labelTagClassName,
            dangerouslySetInnerHTML: {
              __html: label
            }
          })
        );
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          children = _this$props3.children,
          labelClassName = _this$props3.labelClassName;
      return (// eslint-disable-next-line jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for
        _react.default.createElement("label", {
          className: labelClassName || null,
          onBlur: function onBlur(event) {
            return _this2.handleHover(event, false);
          },
          onFocus: this.handleHover,
          onMouseOut: function onMouseOut(event) {
            return _this2.handleHover(event, false);
          },
          onMouseOver: this.handleHover,
          onTouchEnd: function onTouchEnd(event) {
            return _this2.handleHover(event, false);
          },
          onTouchStart: this.handleHover
        }, children, this.renderLabel())
      );
    }
  }]);
  return Label;
}(_react.Component);

(0, _defineProperty2.default)(Label, "propTypes", {
  children: _propTypes.default.node.isRequired,
  handleHover: _propTypes.default.func.isRequired,
  disabled: _propTypes.default.bool,
  isMobile: _propTypes.default.bool,
  label: _propTypes.default.node,
  labelChildren: _propTypes.default.node,
  labelClassName: _propTypes.default.string,
  labelHover: _propTypes.default.bool,
  labelTag: _propTypes.default.string,
  labelTagClassName: _propTypes.default.string
});
(0, _defineProperty2.default)(Label, "defaultProps", {
  disabled: false,
  isMobile: false,
  label: null,
  labelChildren: null,
  labelClassName: null,
  labelHover: true,
  labelTag: 'span',
  labelTagClassName: null
});
var _default = Label;
exports.default = _default;